export default __webpack_public_path__ + "static/media/faq.4fbb0d95.jpg";